import { contracts } from '../../data/contracts'

export default {
	name: 'WATER',
	shortName: 'OWATER',
	contractAddress: contracts[process.env.REACT_APP_NETWORK].waterAddress,
	url: 'http://lorem.com',
	logo: 'tokens/OWater.png'
}
